import React from 'react'
import { Table, Button } from 'react-bootstrap'

export interface StepData {
  title: string
  disabled: boolean
  current: boolean
  onClick: () => void
}

export interface OrderRequestsHeaderProps {
  steps: StepData[]
  title?: string
}

export default (props: OrderRequestsHeaderProps) => {
  const steps = () => props.steps.map(step => (
    <Button className={`${step.current ? " selected" : ''}`} disabled={step.disabled} onClick={step.onClick}>{step.title}</Button>
  ))
  const stepsWithDelimiters = () => steps().reduce((r: JSX.Element[], step: JSX.Element) => r.length ? [...r, <hr/>, step] : [step], [])
  const trs = stepsWithDelimiters().map((item, index) => <td key={index}>{item}</td>)
  return (
    <>
      <h4 className="primary">{ props.title || "ORDER FORM" }</h4>
      <Table className="OrderRequestsHeader">
        <tbody>
          <tr>
            {trs}
          </tr>
        </tbody>
      </Table>
    </>
  )
}
